import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { Form, Typography, Button, Space, Input, Select } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

const { Title } = Typography;

const validationRules = [
  {
    required: true,
    message: getTranslatedString(
      'landlordPortal.applicationManagement.inviteLeadToApply.requiredField'
    ),
  },
];

const AssignPackage = ({ applicationPackages }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString('landlordPortal.baseApplication.assignPackage')}
      </Title>
      <Form.Item
        name="application_package_id"
        rules={validationRules}
        label={getTranslatedString('landlordPortal.baseApplication.assignPackage')}
      >
        <Select>
          {applicationPackages.map((applicationPackage) => (
            <Select.Option key={applicationPackage.id} value={applicationPackage.id}>
              {applicationPackage.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

AssignPackage.propTypes = {
  applicationPackages: PropTypes.array,
};

AssignPackage.defaultProps = {
  applicationPackages: [],
};

export default AssignPackage;
